var map = {
	"./en/bio.ts": [
		45854,
		5854
	],
	"./en/common.ts": [
		23273,
		3273
	],
	"./en/my.ts": [
		30570,
		570
	],
	"./en/priority.ts": [
		96232,
		6232
	],
	"./es/bio.ts": [
		98225,
		8225
	],
	"./es/common.ts": [
		61444,
		1444
	],
	"./es/my.ts": [
		81451,
		1451
	],
	"./es/priority.ts": [
		71849,
		1849
	],
	"./index.ts": [
		74574
	],
	"./ko/bio.ts": [
		50019,
		19
	],
	"./ko/common.ts": [
		34922,
		4922
	],
	"./ko/my.ts": [
		1233,
		1233
	],
	"./ko/priority.ts": [
		57643,
		7643
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 89639;
module.exports = webpackAsyncContext;